import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap["nand2tetris-hdl"] = bracketIndenting()
